@if (fields()) {
  <wl-text-image
    class="container d-block"
    [inverse]="inverse()"
    [title]="title()!"
    [content]="content()!"
    [image]="image()!"
    [primaryButton]="primaryButton()"
    [secondaryButton]="secondaryButton()"
    [microcopy]="microcopy()"
  >
    @if (showAppStoreButtons()) {
      <wl-app-store-buttons
        app-store-buttons
        [appStoreButtonLink]="appStoreButton()!"
        [googlePlayButtonLink]="googlePlayButton()!"
      />
    }
  </wl-text-image>
}
